/**
 * Landing — what users see if they hit the bare domain
 * (https://projects.roughinadvisory.com/) without a project slug.
 *
 * Deliberately spare. Real clients always arrive at /:slug from a link or
 * QR their PM sent. This page is a friendly landing for the lost.
 */
export function Landing() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg)] px-4">
      <div className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-lg shadow-sm p-10 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-[var(--color-ink)]">Project Portal</h1>
        <p className="mt-2 text-sm text-[var(--color-ink-2)]">
          Welcome. To view your project, use the URL or QR code your project manager sent you.
        </p>
        <p className="mt-6 text-xs text-[var(--color-ink-3)]">Rough-In Advisory LLC</p>
      </div>
    </div>
  );
}
